<div box>
  <div title>Acknowledge Email</div>

  <div class="pt-4 pb-8 text-left">
    We were unable to process your acknowledgement at this time. Please contact us for assistance.
    <div class="text-center pt-4">
      <a [href]="environment.websiteUrl">Back to website</a>
    </div>
  </div>
</div>
